import React from 'react';
import {Card, CardBody, CardTitle, Col, Row} from 'reactstrap';
import {Colxx} from '../components/common/CustomBootstrap';
import {barChartOptions} from '../components/charts/config';
import {barValueOnTop} from '../components/charts/util';
import {numberWithCommas, selectStyles} from '../helpers/Utils';
import {withTranslation} from 'react-i18next';
import Bar from '../components/charts/Bar';
import {store} from '../AppRenderer';
import Api from '../services/Api';
import Select from 'react-select';
import {forEach} from 'lodash';

class UsersDistributionByWalletBalance extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      token: 'TMN',
      loading: true,
    };
    this.tokenOptions = store.getState().general.tokens.map(token => ({
      label: token.localeName, value: token.symbol
    }));
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    this.setState({
      loading: true,
    });
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/wallet-levels',
        null,
        {
          cancelToken: null,
        }
      );
      this.setState({
        data: this.getChartData(data),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onChangeToken = token => {
    this.setState({
      loading: true,
      token: token.value,
    });
    setTimeout(() => {
      this.setState({
        loading: false,
      });
    });
  };

  getChartData = data => {
    const {t} = this.props;
    let newData = {};
    forEach(data, (obj, key) => {
      newData = {
        ...newData,
        [key]: {
          labels: obj.in.map((item, index) => {
            if (index === obj.in.length -1) {
              return `${numberWithCommas(item.threshold)} <`;
            }
            return `(${numberWithCommas(obj.in[index + 1].threshold)} , ${numberWithCommas(item.threshold)})`;
          }),
        },
      };
      newData = {
        ...newData,
        [key]: {
          ...newData[key],
          datasets: [
            {
              label: t('Number of users moved from the lower level to the current level'),
              backgroundColor: '#22CFCF',
              data: obj.in.map((item, index) => {
                if (index === obj.in.length - 1) {
                  return item.below;
                }
                return item.below - obj.out[index].below;
              }),
            },
            {
              label: t('Number of users moved from the higher level to the current level'),
              backgroundColor: '#FF4069',
              data: obj.in.map((item, index) => {
                if (index === obj.in.length - 1) {
                  return item.above;
                }
                return item.above - obj.out[index].above;
              }),
            },
          ],
        },
      };
    });
    return newData;
  };

  render () {
    const {loading, data, token} = this.state;
    const {t} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card>
            <CardBody>
              <CardTitle className="text-large text-primary">
                {t('Users distribution by wallet balance')}
              </CardTitle>
              <Row className="mb-5">
                <Col className="col-12 col-md-6 col-lg-3">
                  <span>{t('Wallet')}</span>
                  <Select
                    className="w-100"
                    styles={selectStyles}
                    value={this.tokenOptions.find(option => option.value === token)}
                    onChange={this.onChangeToken}
                    options={this.tokenOptions}
                    placeholder={t('Select')}
                  />
                </Col>
              </Row>
              <Row className='position-relative' style={{height: '360px'}}>
                {loading && <div className='loading position-absolute align-self-center'/>}
                {!loading && <Bar
                  data={data[token]}
                  plugins={[barValueOnTop]}
                  options={{
                    legend: {
                      ...barChartOptions.legend,
                      display: true,
                    },
                    scales: {
                      yAxes: [{...barChartOptions.yAxes, stacked: true}],
                      xAxes: [{...barChartOptions.xAxes, stacked: true}],
                    }
                  }}
                />}
              </Row>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UsersDistributionByWalletBalance);
